module.exports = __webpack_public_path__ + "static/media/lucid-bg-logo.63821090.svg";